var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChalkboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 3.5V12.5C13.5 12.7761 13.7239 13 14 13C14.2761 13 14.5 12.7761 14.5 12.5V3.5C14.5 3.08579 14.2071 2.79289 14.2071 2.79289C13.9142 2.5 13.5 2.5 13.5 2.5H2.5C2.08579 2.5 1.79289 2.79289 1.79289 2.79289C1.5 3.08579 1.5 3.5 1.5 3.5V12.5C1.5 12.7761 1.72386 13 2 13C2.27614 13 2.5 12.7761 2.5 12.5V3.5H13.5Z",
    fill: "#303335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 13H15C15.2761 13 15.5 12.7761 15.5 12.5C15.5 12.2239 15.2761 12 15 12H1C0.723858 12 0.5 12.2239 0.5 12.5C0.5 12.7761 0.723858 13 1 13Z",
    fill: "#303335"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 11V12.5C11.5 12.7761 11.7239 13 12 13C12.2761 13 12.5 12.7761 12.5 12.5V10.5C12.5 10.2239 12.2761 10 12 10H7.5C7.22386 10 7 10.2239 7 10.5V12.5C7 12.7761 7.22386 13 7.5 13C7.77614 13 8 12.7761 8 12.5V11H11.5Z",
    fill: "#303335"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 5.5V8.5C11.5 8.77614 11.7239 9 12 9C12.2761 9 12.5 8.77614 12.5 8.5V5C12.5 4.72386 12.2761 4.5 12 4.5H4C3.72386 4.5 3.5 4.72386 3.5 5V12.5C3.5 12.7761 3.72386 13 4 13C4.27614 13 4.5 12.7761 4.5 12.5V5.5H11.5Z",
    fill: "#303335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChalkboardIcon);
export default __webpack_public_path__ + "static/media/chalkboardIcon.4b63caa0a13589e4d8f5702fa7ebe0c6.svg";
export { ForwardRef as ReactComponent };